@if(loading){

}
@else {
<mat-sidenav-container class="trans-overlay" id="main-drawer-container" >
	<mat-sidenav #appSidenav mode="over" position="start" class="app-sidenav">
		<app-sidenav (onSideNvaAction)="onSideNvaAction($event)" [sideNav]="appSidenav" workMode="tabitPay"></app-sidenav>
	</mat-sidenav>
	@if (step === stepsMap.enter){
	<app-tabitpay-enter-order [options]="childOptions" (enterOrder)="lookUpOrder($event)" (loadOrder)="loadOrder($event)"></app-tabitpay-enter-order>
	} @else {
	<div class="module-container" [class.with-banner]="appService.showAppBanner" *ngIf="step >= stepsMap.ticket">
		<div class="module-bar-fixed">
			@if (step > stepsMap.ticket) {
			<button mat-icon-button color="accent" (mousedown)="goBack()">
				<mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
			</button>
			}
			<span class="title text-truncate" [class.ml-2]="step == stepsMap.ticket">
				<div>{{siteName}}</div>
				@if ($storage.order.tableNO) {
					<small style="position:relative;" [innerHTML]="'OAT.table_no_alt' | translate: {v: $storage.order.tableNO} | safeHtml"></small>
				}
			</span>

			<button mat-icon-button (mousedown)="dialogsService.passOrder()" *ngIf="step >= stepsMap.ticket">
				<mat-icon svgIcon="paper_plane" class="rotate-rtl"></mat-icon>
			</button>
			<button mat-icon-button (mousedown)="toggleTranslation()" *ngIf="appService.regionArgs.translations">
				<mat-icon svgIcon="globe"></mat-icon>
			</button>
			<ng-container *ngIf="step === stepsMap.ticket && appService.regionArgs.enableLogin">
				@if (appService.user) {
				<button mat-mini-fab color="accent" (mousedown)="toggleAppSidenav()" style="box-shadow:none">
					{{appService.user.initials}}
				</button>
				} @else {
				<button mat-icon-button color="accent" (mousedown)="toggleAppSidenav()">
					<mat-icon svgIcon="bars"></mat-icon>
				</button>
				}
			</ng-container>
		</div>

		<div class="module-body">
			<!--AMOUNT STEP-->
			@switch (step) {
				@case (stepsMap.ticket) {
					@if ($storage?.order?.isTabOrder) {
						<app-tabitpay-tab [options]="childOptions" (onContinue)="gotoPaymentClick($event)" (onCheckSelect)="onCheckSelect($event)" *ngIf="$storage.order"></app-tabitpay-tab>
					} @else {
						<app-tabitpay-ticket [options]="childOptions" (onContinue)="gotoPaymentClick($event)" (onCheckSelect)="onCheckSelect($event)" *ngIf="$storage.order"></app-tabitpay-ticket>
					}
				}
				@case (stepsMap.partial) {
					<app-tabitpay-checkout-partial [options]="childOptions" (onContinue)="goFroward($event)" (onPayment)="onPayment($event)"></app-tabitpay-checkout-partial>
				}
				@case (stepsMap.pay) {
					<app-tabitpay-checkout-pay [options]="childOptions" (onPayment)="onPayment($event)"></app-tabitpay-checkout-pay>
				}
			}

		</div>
	</div>
	}
</mat-sidenav-container>
}
